import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-cream-50 pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden" data-id="element-45">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-46">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-47">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-48">
            <div className="inline-flex items-center space-x-2 bg-teal-500/10 text-teal-600 px-3 py-1 rounded-full text-sm font-medium mb-6" data-id="element-49">
              <span className="relative flex h-2 w-2" data-id="element-50">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-500 opacity-75" data-id="element-51"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-500" data-id="element-52"></span>
              </span>
              <span data-id="element-53">For Australian Mums Navigating NDIS</span>
            </div>

            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-navy-900 leading-tight mb-6" data-id="element-54">
              The 10-Minute NDIS Plan{' '}
              <span className="text-teal-500 italic" data-id="element-55">(For Burnt-Out Mums)</span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-56">
              A simple 4-map system to turn your NDIS plan into clear next steps
              — even if you have zero energy today.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-57">
              <Button size="lg" withIcon data-id="element-58">
                Download the Plan Builder — $29
              </Button>
              <p className="text-sm text-gray-500 mt-3 sm:mt-0 sm:ml-4 flex items-center" data-id="element-59">
                <CheckCircle2 className="h-4 w-4 mr-1 text-teal-500" data-id="element-60" />
                Instant PDF Download
              </p>
            </div>

            <div className="flex items-center space-x-4 text-sm text-gray-500" data-id="element-61">
              <div className="flex -space-x-2" data-id="element-62">
                {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center overflow-hidden" data-id="element-63">
                    <span className="text-xs" data-id="element-64">User</span>
                  </div>)}
              </div>
              <p data-id="element-65">Trusted by 500+ families</p>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:h-auto" data-id="element-66">
            <div className="relative rounded-2xl shadow-2xl overflow-hidden border-4 border-white transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/7e4sXquhfxwNKwRJqEXvgd/heylloyd-image-1770549855078.png" alt="The NDIS Autism Plan Builder on a tablet" className="w-full h-auto object-cover" data-id="element-68" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -z-10 top-10 -right-10 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl" data-id="element-69"></div>
            <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-navy-900/10 rounded-full blur-3xl" data-id="element-70"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}